"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageCode = void 0;
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Null"] = "null";
    LanguageCode["Danish"] = "da";
    LanguageCode["English"] = "en";
    LanguageCode["Finnish"] = "fi";
    LanguageCode["French"] = "fr";
    LanguageCode["German"] = "de";
    LanguageCode["Jamaican"] = "jm";
    LanguageCode["Norwegian"] = "no";
    LanguageCode["Spanish"] = "es";
    LanguageCode["Swedish"] = "sv";
})(LanguageCode || (exports.LanguageCode = LanguageCode = {}));
